import { config } from "./config";

export default function Fetcher ( call, feed ) {
  const verbose = false;

  return new Promise ( ( resolve, reject ) => {

    // build form data request from call object iteration.
    // multipart compatible.
    const formData = new FormData();
    Object.keys( call ).forEach( k => {
      formData.append( k, call[k] );
    });

    // TESTING phase check if auth is needed.
    if ( feed === 'nfeed' ){
      formData.append( 'api_user', '382ed594b471d6e8e70c2cd89c698f948112a67bee495d2f433c0e41db6d1d7c' );
      formData.append( 'api_token', '61a4d963cb181d3e49857d459194b3f524bce1768864437747466fcac3ef0246' );
    }

    // fetch.
    fetch( config.api[ feed ], {
      method: 'POST',
      body: formData

      // get response data.
    }).then( res => {
      return res.json();

      // check api response status and return data.
    }).then( data => {

      if (verbose) { console.log( data ); }

      if ( data.status === 'ok' ) {
        resolve( data.result );

      } else {
        // not ok return error object
        reject({ type : 'error', msg : data.response });
      }

    })
    .catch( err => {
      console.log( err );
      reject({ type : 'error', msg : err.message });
    });
  });
}
